
import Link from 'next/link'
import { useSelector } from 'react-redux';
import { React, useState, useEffect } from 'react'
import router from 'next/router'

function FooterMenuItem({ menuTree }) {

    const user = useSelector((state) => state.user);
    var token = false
    var merchant = false
    if (user[0] != undefined) {
        token = user[0].token
        if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
            merchant = true
        }
    }

    const [merchantMenuTree, set_merchantMenuTree] = useState(false)

    const get_footer_menu = (menu) => {
        // function to take all the menus and only extract the header one for rendering here
        var result = menu.filter(obj => {
            return obj.slug == 'footer'
        })
        return result[0]
    }

    const get_link = (item) => {
        // we have a few different options in here

        // blog
        // product
        // taxonomy
        // this has different 'types'
        // landingpage
        // static link
        // other built in one

        // but basically there are 2 types:
        // one that has its url as the 'value' and one that has its url as item->value->url


        switch (item.type) {
            case "Blog":
            case "Product":
            case "Taxonomy":
            case "Page":
                return item.value.url
            case "static-url":
            case "text":
                return item.value
        }
    }

    useEffect(() => {
        if (!router.isReady) return;
        // this one determines what kind of taxonomies we are checking against

        if (merchant) {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }

            // fetch serverside while rendering

            fetch(
                process.env.NEXT_PUBLIC_API_URL + '/menu/merchant/footer',
                {
                    headers: headers,
                    method: 'POST'
                }
            ).then(response => {
                // reject not ok response
                if (!response.ok) {
                    return Promise.reject(response)
                }
                return response.json() // or return response.text()
            })
                .catch(async response => {
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                })
                .then(data => {
                    // wrap this as an array as it sends an object back from the server
                    var menu = (get_footer_menu([data]))
                    set_merchantMenuTree(menu)
                })
                .catch((error) => {
                    console.warn(error);
                });
        }

    }, [token, merchant]);


    return (
        <>


            {(menuTree && menuTree.menuItems && (!merchantMenuTree || !merchantMenuTree.menuItems)) ? (Object.values(menuTree.menuItems).map((menu) => (
                <div className="" key={menu.id}>
                    <h3 className="font-bold text-brand-tertiary text-xl mb-2 leading-none">{menu.name}</h3>
                    {(menu.children) ? (

                        <ul>
                            {menu.children.map((submenu) => (
                                <li key={submenu.id} className="leading-none mt-3">
                                    <Link href={get_link(submenu)}>
                                        <a className="flex items-center group text-brand-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current text-brand-secondary mr-1 group-hover:mr-2 transition-all" width="6.414" height="10.829" viewBox="0 0 6.414 10.829">
                                                <path id="Chevron_Icon" data-name="Chevron Icon" d="M1180.983,1224l4,4,4-4" transform="translate(-1222.586 1190.397) rotate(-90)" fill="none" stroke="#0fa9a2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </svg>
                                            {submenu.name}
                                        </a>
                                    </Link>
                                </li>
                            ))}

                        </ul>
                    ) : ('')
                    }
                </div>
            ))) : ('')}

            {(merchantMenuTree && merchantMenuTree.menuItems) ? (Object.values(merchantMenuTree.menuItems).map((menu) => (
                <div className="" key={menu.id}>
                    <h3 className="font-bold text-brand-tertiary text-xl mb-2 leading-none">{menu.name}</h3>
                    {(menu.children) ? (

                        <ul>
                            {menu.children.map((submenu) => (
                                <li key={submenu.id} className="leading-none mt-3">
                                    <Link href={get_link(submenu)}>
                                        <a className="flex items-center group text-brand-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current text-brand-secondary mr-1 group-hover:mr-2 transition-all" width="6.414" height="10.829" viewBox="0 0 6.414 10.829">
                                                <path id="Chevron_Icon" data-name="Chevron Icon" d="M1180.983,1224l4,4,4-4" transform="translate(-1222.586 1190.397) rotate(-90)" fill="none" stroke="#0fa9a2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </svg>
                                            {submenu.name}
                                        </a>
                                    </Link>
                                </li>
                            ))}

                        </ul>
                    ) : ('')
                    }
                </div>
            ))) : ('')}

        </>
    );
}

export default FooterMenuItem;